import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class KleepSize extends Component {
  /** @type {((event: MouseEvent) => void) | undefined} */
  #handleClick;

  /** @type {((event: MessageEvent) => void) | undefined} */
  #handleMessage;

  /** @type {((event: Event) => void) | undefined} */
  #handleVariantSelected;

  connectedCallback() {
    super.connectedCallback();
    if (this.parentElement !== document.body) {
      const existing = /** @type {HTMLElement | null} */ (document.body.querySelector(':scope > kleep-size'));
      if (existing) {
        existing.dataset.productId = this.dataset.productId ?? '';
        existing.dataset.variantId = this.dataset.variantId ?? '';
        this.remove();
        return;
      }
      document.body.appendChild(this);
      return;
    }

    this.#handleClick = (event) => {
      const target = /** @type {Element | null} */ (event.target);
      const button = target?.closest('[data-kleep-open]');
      if (!button) return;

      const drawerTrigger = /** @type {(HTMLElement & {closeDialog?: (opts?: {immediate?: boolean}) => void}) | null} */ (
        target?.closest('drawer-trigger') ?? null
      );

      this.createIframe();
      this.style.display = 'block';

      if (drawerTrigger?.closeDialog) {
        const trigger = drawerTrigger;
        requestAnimationFrame(() => trigger.closeDialog?.({ immediate: true }));
      }
    };

    this.#handleMessage = (event) => {
      if (!event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'closeIframe' || event.data.action === 'closeIframe') {
        this.close();
      }
    };

    this.#handleVariantSelected = (event) => {
      if (!(event instanceof CustomEvent)) return;
      /** @type {string | undefined} */
      const id = event.detail?.resource?.id;
      if (id) {
        this.dataset.variantId = String(id);
      }
    };

    document.addEventListener('click', /** @type {EventListener} */ (this.#handleClick));
    window.addEventListener('message', /** @type {EventListener} */ (this.#handleMessage));
    document.addEventListener(ThemeEvents.variantSelected, /** @type {EventListener} */ (this.#handleVariantSelected));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#handleClick) document.removeEventListener('click', /** @type {EventListener} */ (this.#handleClick));
    if (this.#handleMessage) window.removeEventListener('message', /** @type {EventListener} */ (this.#handleMessage));
    if (this.#handleVariantSelected) document.removeEventListener(ThemeEvents.variantSelected, /** @type {EventListener} */ (this.#handleVariantSelected));
  }

  /** @returns {string} */
  buildUrl() {
    const params = new URLSearchParams({
      domain: this.dataset.domain ?? '',
      product_id: this.dataset.productId ?? '',
      customer_id: this.dataset.customerId ?? '',
      lang: this.dataset.lang ?? '',
      countryCode: this.dataset.countryCode ?? '',
      variantId: this.dataset.variantId ?? '',
      category: 'clothing',
    });
    return `${this.dataset.baseUrl}?${params.toString()}`;
  }

  createIframe() {
    this.innerHTML = '';
    const iframe = document.createElement('iframe');
    iframe.src = this.buildUrl();
    iframe.title = 'Kleep.ai';
    Object.assign(iframe.style, { width: '100%', height: '100%', border: 'none' });
    this.appendChild(iframe);
  }

  close() {
    this.style.display = 'none';
    this.innerHTML = '';
  }
}

customElements.define('kleep-size', KleepSize);
